import { atom } from 'jotai';
import { MediaViewerAtom, MediaViewerAtomV2 } from '../typings/media-viewer';
import { MessageTypesEnum } from '../typings/message-types';

export const mediaViewerAtom = atom<MediaViewerAtom>({
  isMediaViewerActive: false,
  message: undefined,
});

export const mediaViewerAtomV2 = atom<MediaViewerAtomV2>({
  isMediaViewerV2Active: false,
  filesUrl: [],
  messageTypes: [MessageTypesEnum.IMAGE],
  forwardPayloads: [],
  activeIndex: 0,
});
